import Typography from '@eduzz/houston-ui/Typography';
import { Grid } from '@material-ui/core';
import PermissionHide from 'components/PermissionHide';
import React, { memo } from 'react';
import { FormattedNumber } from 'react-intl';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  product: IProduct;
}

enum ChargeTypes {
  SIGNATURE = 'A',
  NORMAL = 'N',
  FREE = 'G',
  OPEN = 'L',
}

const ShowPrice = ({ product }: IProps) => {
  return (
    <>
      {product.charge_type === ChargeTypes.SIGNATURE && (
        <>
          <div className='price'>
            <FormattedNumber value={product.recurring_value} format='BRL' />
          </div>
          recorrente
        </>
      )}

      {product.charge_type === ChargeTypes.NORMAL && (
        <div className='price'>
          <FormattedNumber value={product.price} format='BRL' />
        </div>
      )}

      {product.charge_type === ChargeTypes.FREE && <>Grátis</>}

      {product.charge_type === ChargeTypes.OPEN && <>Valor Aberto</>}
    </>
  );
};

const ProductDetails = ({ product }: IProps) => {
  return (
    <>
      <Grid item xs={12} sm='auto'>
        <img className='image' src={product.image} alt='Preview' />
      </Grid>
      <Grid item xs={12} md={5} className='content-preview'>
        <Typography size='sm' weight='semibold'>
          #{product.id} {product.title}
        </Typography>
        <span>
          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
            <ShowPrice product={product} />
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </span>
      </Grid>
    </>
  );
};

export default memo(ProductDetails);
